import { createRootRouteWithContext, type ErrorComponentProps, Outlet, useRouter } from '@tanstack/react-router'
import { Button } from '@thom/folio-ui/components/ui/button'
import { Toast } from '@journ/bloom/toast'
import { ContainerProvider } from '@thom/folio-ui/app/container'
import { NuqsAdapter } from 'nuqs/adapters/tanstack-router'
import type { RouterContext } from '@thom/folio-ui/routing/router-context'

const RootComponent = () => {
	const { container } = Route.useRouteContext()

	return (
		<ContainerProvider container={container}>
			<NuqsAdapter>
				<Outlet />
				<Toast.Provider position='bottom-right' />
			</NuqsAdapter>
		</ContainerProvider>
	)
}

const ErrorComponent = ({ error }: ErrorComponentProps) => {
	const router = useRouter()

	return (
		<main className='flex min-h-dvh w-full flex-col items-center justify-center gap-6 p-8'>
			<div className='max-w-md space-y-2 text-center'>
				<h1 className='font-serif text-lg'>Something went wrong</h1>
				<p className='text-dim text-sm'>{error instanceof Error ? error.message : 'Unknown error'}</p>
			</div>

			<Button tone='outline' onClick={() => router.invalidate()}>
				Try again
			</Button>
		</main>
	)
}

export const Route = createRootRouteWithContext<RouterContext>()({
	component: RootComponent,
	errorComponent: ErrorComponent,
})
